// 8 new original local blog posts appended to existing 4. Total 12.
import { BLOG_POSTS as EXISTING, BLOG_CATEGORIES as EXISTING_CATS } from "@/data/blogPosts";

const P = (text) => ({ type: "p", text });
const H = (text) => ({ type: "h2", text });
const L = (items) => ({ type: "list", items });

const NEW_POSTS = [
  {
    slug: "moving-checklist-casper-8-weeks",
    title: "8-Week Moving Checklist for Casper & Natrona County",
    excerpt: "A realistic 8-week timeline for planning a stress-free move in Casper, Mills, Bar Nunn, and surrounding Natrona County — packing, utilities, schools, and moving day.",
    image: "https://images.pexels.com/photos/4569340/pexels-photo-4569340.jpeg",
    date: "2026-06-14", readMin: 8, category: "Guides",
    seoTitle: "8-Week Moving Checklist for Casper WY | Crosstown Movers",
    metaDesc: "Free 8-week moving checklist for Casper and Natrona County families. Week-by-week tasks, utilities, packing, and moving-day essentials.",
    sections: [
      P("A great move rarely happens by accident. This week-by-week checklist is what our Casper crews wish every family had — realistic, local, and free."),
      H("8 weeks out — plan and organize"),
      L(["Inventory every room and start decluttering","Request quotes from 2–3 Wyoming movers","Set a budget with a 10–15% cushion","Start a moving binder or shared note"]),
      H("6 weeks out — schedule and notify"),
      L(["Book your moving date","Notify your child's school in Casper or Natrona County SD","Start using up frozen food","Order specialty packing materials"]),
      H("4 weeks out — utilities & address"),
      L(["Schedule utility disconnect/connect (see our Casper Utilities resource)","File USPS change of address","Update driver license & vehicle registration","Confirm parking/access at both addresses"]),
      H("2 weeks out — pack non-essentials"),
      L(["Pack out-of-season items, books, decor","Label every box with room + contents","Refill prescriptions","Confirm crew size and moving-day timing with Crosstown Movers"]),
      H("1 week out — finalize"),
      L(["Pack a 'first-night' bag for each person","Empty & defrost the freezer","Withdraw small cash for tips (optional but appreciated)","Take utility meter photos on move-out day"]),
      H("Moving day"),
      L(["Be present for walk-through with the crew","Keep phone charger + water accessible","Do a final empty-house walk before locking up","Sign paperwork after items are placed"]),
      H("First week in your new Casper home"),
      P("Unpack the kitchen first, then bedrooms. Meet 2 neighbors. Locate the nearest urgent care, grocery, and gas station. Welcome home."),
    ],
  },
  {
    slug: "cost-factors-hiring-movers-casper-wy",
    title: "What Affects the Cost of Hiring Movers in Casper, WY",
    excerpt: "The honest breakdown of the factors that move your moving quote up or down — no fixed prices, just clear answers so you can compare quotes intelligently.",
    image: "https://images.pexels.com/photos/4553183/pexels-photo-4553183.jpeg",
    date: "2026-06-28", readMin: 6, category: "Pricing",
    seoTitle: "Casper WY Moving Costs Explained | Crosstown Movers",
    metaDesc: "Which factors raise or lower a Casper moving quote — home size, crew, distance, packing, specialty items, and seasonality — from Wyoming pros.",
    sections: [
      P("Every Wyoming moving quote is a mix of the same core inputs. Here's what actually moves the number — and what shouldn't."),
      H("Home size & item volume"),
      P("More rooms and more heavy furniture mean more hours or a larger truck. Get quotes off an inventory list, not a phone-guess."),
      H("Crew size"),
      P("A 3-person crew often finishes faster than a 2-person crew — hourly cost goes up, total cost can go down. Ask what the mover recommends for your home size."),
      H("Distance & route"),
      L(["Within Casper/Mills: hourly local rate","Casper ↔ Cheyenne / Laramie / Riverton: long-distance quote","Interstate: weight + distance"]),
      H("Access — stairs, elevators, parking"),
      P("Third-floor walk-ups, long carries from truck to door, or elevator reservations all add labor time. Tell your mover about these upfront."),
      H("Packing services"),
      L(["Full-service packing","Partial (kitchen/fragile only)","Just supplies delivered before moving day"]),
      H("Specialty & heavy items"),
      P("Pianos, safes, appliances, and pool tables require the right crew and equipment. Never a hidden surprise if disclosed at quote time."),
      H("Season & day of week"),
      P("May–September is peak in Wyoming. Weekends and month-ends book fastest. Mid-week, mid-month, off-peak = best rates."),
      H("Red flags in a quote"),
      L(["No written estimate","Deposit required with cash only","'Fuel surcharge added later'","No physical address or WY license visible"]),
    ],
  },
  {
    slug: "winter-moving-wyoming-wydot",
    title: "Winter Moving in Wyoming: Wind, Snow, and WYDOT Road Conditions",
    excerpt: "Wyoming winters have their own rules. What to check, what to prep, and where to get official road conditions before a January move.",
    image: "https://images.pexels.com/photos/3933889/pexels-photo-3933889.jpeg",
    date: "2026-07-05", readMin: 6, category: "Tips",
    seoTitle: "Winter Moving in Wyoming | Casper Moving Tips | Crosstown Movers",
    metaDesc: "Snow, wind, and road-condition planning for a winter move in Casper and greater Wyoming — official WYDOT resources included.",
    sections: [
      P("Wind is the wildcard. Snow slows you down; wind stops you. Here's how our Casper crews prepare for winter moves."),
      H("Check WYDOT before moving day"),
      P("Wyoming's road status changes fast. Get real-time closures and advisories at the official WYDOT site: https://www.wyoroad.info/"),
      H("Wind considerations"),
      L(["I-80 west of Cheyenne closes to high-profile vehicles more days than you'd think","Reschedule vs push through — a safe delay beats a truck rollover","Padding + strap heavier items toward the truck floor"]),
      H("Snow & ice checklist"),
      L(["Salt both driveways 24 hours before","Lay towels or floor runners at every exterior door","Turn on heat at destination before arrival","Wrap electronics — cold + condensation kills"]),
      H("Cold-sensitive items"),
      L(["Plants: transport in your car with heat on","Liquids that can freeze/burst: bottled water, wine","Wooden furniture: rapid temperature change can crack finishes"]),
      H("What if a storm hits?"),
      P("Ask your mover about reschedule policy before booking. Crosstown Movers reschedules winter moves without penalty when WYDOT closes your route."),
    ],
  },
  {
    slug: "moving-casper-to-mills-bar-nunn-evansville",
    title: "Moving Between Casper, Mills, Bar Nunn, and Evansville: The Local Guide",
    excerpt: "The differences that actually matter when moving inside greater Casper — commute, schools, utilities, and access.",
    image: "https://images.pexels.com/photos/32929232/pexels-photo-32929232.jpeg",
    date: "2026-07-19", readMin: 7, category: "Guides",
    seoTitle: "Moving Between Casper Mills Bar Nunn Evansville | Crosstown Movers",
    metaDesc: "Local Wyoming moving guide: what's different about moving to Mills vs Bar Nunn vs Evansville from Casper — commute, services, and access.",
    sections: [
      P("Locals know these towns feel different even though they're minutes apart. Here's what to expect when you move between them."),
      H("Casper → Mills"),
      P("Just across the river. Similar utility providers, generally faster access via CY Avenue or Wyoming Blvd. Watch for narrow older streets when routing the truck."),
      H("Casper → Bar Nunn"),
      P("Bar Nunn is quiet and residential. Longer driveways and larger lots — verify truck turning space. HOA rules on some streets."),
      H("Casper → Evansville"),
      P("Small-town feel, close to I-25. Very fast for movers, easy access for larger trucks."),
      H("Casper → Glenrock"),
      P("~30 minutes east on I-25. Adds meaningful drive time to any hourly move. Plan the earliest crew start you can."),
      H("Utility handoff"),
      L(["Different water/sewer providers depending on town","Rocky Mountain Power covers most areas","Trash pickup varies — Bar Nunn has its own"]),
      H("Which is easiest to move to?"),
      P("Evansville and Mills for truck access. Bar Nunn takes slightly more setup. All are inside our standard local rate zone."),
    ],
  },
  {
    slug: "residential-vs-commercial-moves-office-relocation",
    title: "Residential vs. Commercial Moves: How Planning Actually Differs",
    excerpt: "Residential moves happen once every few years. Office moves have to happen on a Sunday and be running Monday. Here's how we approach each.",
    image: "https://images.unsplash.com/photo-1772724316733-57e51acf7fac",
    date: "2026-08-02", readMin: 6, category: "Guides",
    seoTitle: "Residential vs Commercial Moves in Wyoming | Crosstown Movers",
    metaDesc: "How commercial office relocation differs from residential moves — planning, downtime, IT, and crew requirements from Wyoming pros.",
    sections: [
      H("The core difference: downtime"),
      P("Residential moves are about care. Commercial moves are about time-to-recovery. Every planning decision flows from that."),
      H("Residential planning inputs"),
      L(["Home size and access","Fragile and sentimental items","Packing preferences","Family schedule (school, work)"]),
      H("Commercial planning inputs"),
      L(["Business hours & when downtime is acceptable","IT infrastructure timing","Furniture systems & seating chart","Compliance (HIPAA, records)","Building rules at both addresses"]),
      H("Timeline reality check"),
      L(["Residential: 2–6 weeks lead time","Small office: 3–6 weeks","Medium office: 6–8 weeks","Large / multi-floor: 12+ weeks"]),
      H("Why phased office moves work"),
      P("Move accounting Friday. Sales Sunday. IT overnight. Nobody misses a Monday. It costs slightly more in hours but saves days of lost productivity."),
    ],
  },
  {
    slug: "packing-fragile-items-artwork-tvs-antiques",
    title: "Packing Fragile Items, Artwork, TVs, and Antiques the Right Way",
    excerpt: "The specific packing methods our crews use to protect the items that make a house feel like yours.",
    image: "https://images.unsplash.com/photo-1758523671531-75bd8a19e63b",
    date: "2026-08-16", readMin: 8, category: "Packing",
    seoTitle: "How to Pack Fragile Items, Art, TVs & Antiques | Crosstown Movers",
    metaDesc: "Pro-mover packing techniques for artwork, TVs, mirrors, antiques, and glassware — supplies list and step-by-step.",
    sections: [
      H("Supplies to buy first"),
      L(["Dish-pack (double-wall) boxes","Corner protectors","Mirror/picture boxes","Bubble wrap 3/16\" for wrapping, 1/2\" for cushioning","Foam sheets","Painter's tape (never masking tape on artwork)"]),
      H("Artwork & framed pieces"),
      L(["Apply painter's tape in an X across the glass","Wrap in glassine or acid-free paper","Sandwich between foam sheets","Ship vertically in a picture box"]),
      H("Flat-screen TVs"),
      L(["Original box is ideal","Otherwise: soft cloth over screen, foam pad, then bubble wrap","Ship vertically like a picture","Never lay flat"]),
      H("Antiques & heirlooms"),
      P("Photograph them before packing. Custom crates for rare pieces. Never wrap unfinished wood in plastic — it traps moisture."),
      H("Mirrors"),
      L(["Tape the X","Corner protectors","Bubble wrap","Ship in mirror box, vertical"]),
      H("Small fragiles"),
      P("Stuff hollow items with crumpled paper. Wrap individually. Heavy items on bottom of the box, lighter on top. Label FRAGILE on two sides."),
    ],
  },
  {
    slug: "senior-assisted-living-relocation-guide",
    title: "A Compassionate Guide to Senior & Assisted-Living Moves",
    excerpt: "Moving a parent or aging loved one is emotional. Here's a practical, respectful path through it — from downsizing to the first night.",
    image: "https://images.pexels.com/photos/7551617/pexels-photo-7551617.jpeg",
    date: "2026-08-30", readMin: 7, category: "Guides",
    seoTitle: "Senior Moving & Assisted-Living Relocation | Crosstown Movers",
    metaDesc: "Compassionate senior moving guide — downsizing, timeline, emotional considerations, and coordinating with assisted living in Wyoming.",
    sections: [
      P("A senior move is 20% logistics and 80% emotion. Do the emotional work first."),
      H("Start with the floor plan"),
      P("Get the exact room measurements from the new community. Decide what fits before deciding what to keep."),
      H("The 'yes / not sure / no' method"),
      L(["Yes: essential daily-use items go first","Not sure: photograph, box, and revisit in 90 days","No: donate, gift to family, or arrange responsible disposal"]),
      H("Coordinating with the community"),
      L(["Confirm approved move-in days and times","Ask about elevator reservations","Check restrictions on furniture pieces","Coordinate first-night essentials with staff"]),
      H("Emotional cues to watch for"),
      P("Slow down at photos, letters, and heirlooms. Don't force a decision. Some items don't need to be decided in one day."),
      H("First night"),
      L(["Familiar quilt on the bed","Photos of family within eyesight","One familiar smell (lotion, laundry detergent)","A written note from you"]),
    ],
  },
  {
    slug: "how-to-choose-a-legitimate-wyoming-mover",
    title: "How to Choose a Legitimate Wyoming Moving Company (Questions to Ask)",
    excerpt: "Not every 'moving company' is one. Here are the questions that separate real Wyoming movers from truck-and-a-guy scams.",
    image: "https://images.pexels.com/photos/4489732/pexels-photo-4489732.jpeg",
    date: "2026-09-13", readMin: 7, category: "Guides",
    seoTitle: "How to Choose a Legitimate Wyoming Moving Company | Crosstown Movers",
    metaDesc: "Nine questions to ask any Wyoming moving company before you book — protect yourself from moving scams.",
    sections: [
      H("1. Are you licensed and insured in Wyoming?"),
      P("Any legitimate mover answers yes and can email you proof of insurance."),
      H("2. Where is your physical address?"),
      P("A real address in Wyoming — not a P.O. box or a Google Maps pin at a truck rental."),
      H("3. How long have you been in business?"),
      P("Reference checks matter. Long-standing local movers have accountability. Crosstown Movers has been in Wyoming since 1980."),
      H("4. Do you provide written estimates?"),
      P("Verbal estimates lead to disputes. Get it in writing — inclusive of fuel, mileage, materials."),
      H("5. Is there a deposit? How is it paid?"),
      P("Small deposits paid by credit card are normal. Full-price cash deposits are a red flag."),
      H("6. Can I see recent reviews and references?"),
      P("Look for detailed, story-driven reviews across multiple platforms. Ask for a repeat customer's name and number."),
      H("7. How do you handle damages?"),
      P("Real movers have a claims process and named coverage tiers."),
      H("8. Who will be on my crew?"),
      P("W-2 employees, background-checked, uniformed. Not day labor booked that morning."),
      H("9. What's not included?"),
      P("Ask specifically about stairs, long carries, specialty items, weekend rates, and packing supplies. Everything should be in writing."),
    ],
  },
];

// Merge and re-export. Newer posts appear first automatically by date sort in BlogIndex.
export const BLOG_POSTS = [...NEW_POSTS, ...EXISTING];
export const BLOG_CATEGORIES = EXISTING_CATS;
